import Router from "next/router";
import { useSession } from "next-auth/react";
import Script from "next/script";
import LandingPageBackground from "@/admin/molecules/LandingPageComponents/LandingPageBackground";
import HomeHeader from "./seoComponent";

function Home(): JSX.Element {
  const { status } = useSession();

  if (status === "authenticated") {
    Router.replace(
      {
        pathname: "/candidate/course-library/my-courses/all-courses",
      },
      "/candidate/course-library/my-courses/all-courses"
    );
  } else {
    return (
      <>
        <HomeHeader title="MyEdVault Home Page" />
        <div className="w-full h-screen ">
          <Script
            strategy="lazyOnload"
            src="https://embed.tawk.to/6877fdff3606072bf84a2cf9/1j0abgbbv"
          />
          <LandingPageBackground />
        </div>
      </>
    );
  }
  return (
    <div className="flex place-content-center h-screen">
      <div className="self-center">Loading...</div>
    </div>
  );
}

export default Home;
